import { useState } from "react";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import styled from "styled-components";
import Arrow from "./Arrow";

const ServicesContainer = styled.div<{ showItem?: number }>`
    padding: 30px 15px 20px 15px;
    position: relative;

    header {
        text-transform: uppercase;
        color: #FF5701;
        font-weight: bold;
        font-size: 1.1rem;
        letter-spacing: 5px;
        position: relative;
    }

    header:after {
        content: "";
        width: 70%;
        height: 2px;
        background: #FF5701;
        display: block;
        position: absolute;
        top: 50%;
    }

    header:after {
        right: 0;
    }

    main {
        display: flex;
    }

    main > div {
        width: 100%;
        padding: 40px;
    }

    main > div:first-child {
        padding-left: 0;
    }

    main > div:last-child {
        padding-right: 0;
    }

    button {
        display: none;
    }

    @media (max-width: 800px) {
        header {
            letter-spacing: 0;
        }

        header:after {
            width: 30%;
        }

        main {
            flex-direction: column;
        }

        main > div {
            display: none;
            padding: 20px !important;
        }

        main > div:nth-child(${({ showItem }) => showItem}) {
            display: block;
        }

        button {
            display: flex;
            position: absolute;
            top: 200px;
            transform: translateY(-50%);
            z-index: 1;
        }

        button.left {
            left: 10px;
        }

        button.right {
            right: 10px;
        }
    }
`;

type ServicesSectionProps = {
    title: string;
    children: any;
};

const ServicesSection: React.FC<ServicesSectionProps> = ({ title, children }) => {
    const [currentItem, setCurrentItem] = useState(1);

    return (
        <ServicesContainer showItem={currentItem} className="container">
            <header>
                {title}
            </header>

            {currentItem > 1 ? (
                <Arrow className="left" onClick={() => setCurrentItem(i => i - 1)}>
                    <HiChevronLeft />
                </Arrow>
            ) : (
                ""
            )}

            <main>
                {children}
            </main>

            {currentItem < 3 ? (
                <Arrow className="right" onClick={() => setCurrentItem(i => i + 1)}>
                    <HiChevronRight />
                </Arrow>
            ) : (
                ""
            )}
        </ServicesContainer>
    );
};

export default ServicesSection;
